import { Step } from "react-joyride";

const listProposalsTourSteps: Step[] = [
  {
    target: ".tour-create-proposal-button",
    content: "Click here to begin a proposal.",
    buttons: ["close"],
    overlayClickAction: false,
    dismissKeyAction: false,
  },
];

export default listProposalsTourSteps;
